import type { HumanProportions } from './human.js';

/** Body fat thickens the trunk (most at the belly and waist), neck, limbs and hips, keeping joint lengths fixed so animation is unchanged. */
export function fatProportions(source: HumanProportions, fatness = source.fatness): HumanProportions {
  const fat = Math.max(0, Math.min(1, fatness));
  if (fat === 0) return source.fatness === 0 ? source : { ...source, fatness: 0 };
  const p = { ...source, fatness: fat };
  p.shoulderHalfWidth += .008 * fat; p.chestHalfWidth += .018 * fat; p.ribHalfWidth += .032 * fat; p.waistHalfWidth += .048 * fat; p.pelvisHalfWidth += .038 * fat;
  p.waistDepth += .032 * fat; p.pelvisDepth += .026 * fat; p.glute += .012 * fat; p.hipHalfWidth += .014 * fat;
  p.neckRadius += .012 * fat; p.limbThickness += .24 * fat; p.thighFullness *= 1 + .2 * fat; p.handScale *= 1 + .05 * fat;
  if (p.bust) p.bust *= 1 + .25 * fat;
  // Fat fills the inner thighs toward each other, rounds the hips and softens the crease beneath the seat.
  const pelvis = source.pelvisShape;
  p.pelvisShape = { ...pelvis, thighGap: pelvis.thighGap - .03 * fat, innerThigh: pelvis.innerThigh + .012 * fat, flare: pelvis.flare + .012 * fat, front: pelvis.front + .006 * fat,
    gusset: pelvis.gusset + .3 * fat, gluteFold: pelvis.gluteFold * (1 - .5 * fat) };
  const front = [0, .012, .03, .06, .066, .046, .022, .008, .004, .004, .003, .002, .002];
  const back = [0, .01, .022, .03, .03, .022, .014, .008, .004, .004, .003, .002, .002];
  p.trunk = { front: source.trunk.front.map((v, i) => v + front[i] * fat), back: source.trunk.back.map((v, i) => v + back[i] * fat) };
  p.neck = { front: source.neck.front.map(v => v + .01 * fat), back: source.neck.back.map(v => v + .012 * fat) };
  p.headCacheKey = `${source.headCacheKey ?? source.id}:fat:${fat}`;
  return p;
}
